import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { NAV } from "./Header";
import { SocialLinks } from "./Social";
import { useSettings } from "@/context/SettingsContext";
import { NewsletterForm } from "./Newsletter";
import { profileEntries } from "@/lib/profiles";

export default function Footer() {
  const { settings } = useSettings();
  return (
    <footer className="border-t border-white/10 bg-[#0d0e12] pb-28" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-12 md:grid-cols-[2fr_1fr_1fr]">
        <div className="space-y-5">
          <Logo />
          <p className="text-sm text-zinc-400 max-w-sm">{settings.tagline}</p>
          <p className="font-mono-tga text-xs tracking-[0.2em] text-emerald-400" data-testid="footer-domain">www.thegrooveanomalyrecords.com</p>
          <div className="pt-2 space-y-2">
            <p className="font-mono-tga text-[10px] uppercase tracking-[0.3em] text-zinc-500">Avvisami delle nuove uscite</p>
            <NewsletterForm prefix="footer-newsletter" compact />
          </div>
        </div>
        <div className="space-y-3">
          <p className="font-mono-tga text-[10px] uppercase tracking-[0.3em] text-zinc-500">Naviga</p>
          {NAV.map((n) => (
            <Link key={n.id} to={n.to} className="block text-sm text-zinc-300 hover:text-emerald-400 transition-colors" data-testid={`footer-${n.id}-link`}>{n.label}</Link>
          ))}
        </div>
        <div className="space-y-4">
          <p className="font-mono-tga text-[10px] uppercase tracking-[0.3em] text-zinc-500">Seguici</p>
          <SocialLinks prefix="footer-social" />
          {profileEntries(settings).length > 0 && (
            <div className="flex flex-wrap gap-2 pt-1" data-testid="footer-profiles">
              {profileEntries(settings).map((p) => (
                <a key={p.key} href={p.url} target="_blank" rel="noopener noreferrer me" data-testid={`footer-profile-${p.key}`}
                  className="rounded-full border border-white/20 px-3 py-1 font-mono-tga text-[10px] uppercase tracking-[0.15em] text-zinc-200 hover:border-emerald-400 hover:text-emerald-300 transition-colors">{p.label.split(" (")[0]}</a>
              ))}
            </div>
          )}
          {settings.contact_email && <a href={`mailto:${settings.contact_email}`} className="block text-sm text-zinc-300 hover:text-emerald-400" data-testid="footer-email">{settings.contact_email}</a>}
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pb-6 font-mono-tga text-[10px] uppercase tracking-[0.25em] text-zinc-600">
        © {new Date().getFullYear()} The Groove Anomaly records — Etichetta indipendente
      </div>
    </footer>
  );
}
